import { Buffer } from 'buffer';
// @ts-ignore
window.Buffer = Buffer;
export const encodeJsonToBase64 = (object) => {
    const json = JSON.stringify(object);
    return Buffer.from(json).toString('base64');
};
export const decodeBase64ToJson = (str) => {
    const json = Buffer.from(str, 'base64').toString();
    return JSON.parse(json);
};
